import axios from "axios";
import * as types from "../../mutation-types";
import endpoints from "../../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store audits data
    endpoint: endpoints.genreports_daily_monthly_income.endpoint, // "report/aggregates/daily-monthly-income"
  },
  // -----------------------------------------------------------------
  getters: {
    endpoint: state => state.endpoint
  },
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, { body, print }) => {
      let api =
        context.rootGetters["global/apiUrl"] + "/" + context.state.endpoint;
      if (print === true) {
        api += "?print=true";
      }
      const paginationData = body;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    }
  }
};
